import { useRef } from "react";
import { Heart } from "lucide-react";
import { fireHeartConfetti } from "@/components/ratings/HeartConfetti";
import { cn } from "@/lib/utils";

/**
 * "Amei" da comunidade (substitui a curtida). Quem adiciona o disco já entra
 * com o próprio amei — e pode retirá-lo clicando de novo.
 */
export function UpvoteButton({
  count,
  active,
  onClick,
  size = "md",
  className,
}: {
  count: number;
  active?: boolean;
  onClick?: () => void;
  size?: "sm" | "md";
  className?: string;
}) {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const dims = size === "sm" ? "h-7 gap-1 px-2 text-[11px]" : "h-8 gap-1.5 px-2.5 text-[12px]";
  const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  return (
    <button
      ref={buttonRef}
      type="button"
      aria-pressed={!!active}
      aria-label={active ? "Remover amei" : "Amei"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!active) fireHeartConfetti(buttonRef.current);
        onClick?.();
      }}
      className={cn(
        "relative inline-flex shrink-0 items-center rounded-full border font-semibold tabular-nums transition-all active:scale-95",
        dims,
        active
          ? "border-rose-500/60 bg-rose-500/15 text-rose-500"
          : "border-border/60 bg-surface/60 text-muted-foreground hover:border-foreground/30 hover:text-rose-500",
        className,
      )}
    >
      <span className="relative grid place-items-center">
        <Heart className={cn(iconSize, active && "fill-current")} strokeWidth={2.5} />
        <Heart
          key={active ? "filled" : "empty"}
          className={cn(
            "absolute inset-0 scale-0 text-rose-500 opacity-0 transition-all duration-200 ease-out",
            iconSize,
            active && "scale-100 opacity-100",
            "fill-current",
          )}
          strokeWidth={2.5}
          aria-hidden
        />
      </span>
      {count}
    </button>
  );
}

